export default __webpack_public_path__ + "static/char-thumb-11-dc9d95818c01ba3617a7ec10c3e6f895.png";